import { invoiceRuleService } from "./repository";

export default {
    async getInvoiceRules() {
        return invoiceRuleService.get("/management/rules");
    },
    async createRule(rule) {
        return invoiceRuleService.post("/management/rules", rule);
    },
    async updateRule(id, rule) {
        return invoiceRuleService.put(`/management/rules/${id}`, rule);
    },
    async deleteRule(id) {
        return invoiceRuleService.delete(`/management/rules/${id}`);
    }
};
